<script>
import { mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import ResizableTextarea from '../inputs/resizable-textarea.js';
import EmojiData from 'emoji-mart-vue-fast/data/all.json';
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import custom from '../emojis/custom-emojis.js';

export default {
  name: 'CpTextEditor',
  components: {
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpTextInput: require('../inputs/text').default,
    CpCloudinaryImageInput: require('../inputs/cloudinary-image').default,
    CpCloudinaryVideoInput: require('../inputs/cloudinary-video').default,
    CpVideoInput: require('../inputs/video').default,
    ResizableTextarea,
    CpDialog: require('../dialog').default,
    CpModalGifs: require('../gifs/modal-gifs').default,
    CpBaseSvgIcon: require('../base-svg-icon').default,
    GifIcon: require('../social-feed/icons/gif').default,
    CpWysiwygInput: require('../inputs/wysiwyg').default,
    CpButton: require('../button').default,
    EmojiData,
    Picker,
    EmojiIndex,
    custom,
    textIncludeUrl: require('../mixins/utils.js').default,
    isVideoEmbed: require('../mixins/utils.js').default,
    hasDataUrl: require('../mixins/utils.js').default,
    isAnchorTag: require('../mixins/utils.js').default,
    OpenGraphPreview: require('../components/OpenGraphPreview').default,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Share your opinion',
    },
    inputGroup: {
      type: Boolean,
      default: false,
    },
    loadingSend: {
      type: Boolean,
      default: false,
    },
    withBackground: {
      type: Boolean,
      default: true,
    },
    primaryBtnType: {
      type: Boolean,
      default: true,
    },
    submitButtonTitle: {
      type: String,
      default: 'Post',
    },
    isMessagingToRep: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: this.text,
      sendFailed: false,
      type: 'none',
      image: null,
      video: null,
      showGifsModal: false,
      gif: null,
      isVisible: false,
      emojiSize: 38,
      textIsUrl: false,
      timer: null,
      sendToRepresentatives: false,
      showLobbyDialog: false,
      commentToRep: null,
    };
  },
  computed: {
    categoriesData() {
      return {
        search: 'Search',
        notfound: 'No Emoji Found',
        categories: {
          search: 'Search Results',
          recent: 'Frequently Used',
          custom: 'Political',
          smileys: 'Smileys & Emotion',
          people: 'People & Body',
          nature: 'Animals & Nature',
          foods: 'Food & Drink',
          activity: 'Activity',
          places: 'Travel & Places',
          objects: 'Objects',
          symbols: 'Symbols',
          flags: 'Flags',
        },
      };
    },
    emojiData() {
      return new EmojiIndex(EmojiData, {
        custom,
      });
    },
    mediaData() {
      if (this.image || this.video || this.gif) {
        return true;
      }
    },
    ...mapState(useUserStore, ['isUserLogin']),
  },
  methods: {
    addEmoji(emoji) {
      if (emoji.custom == true) {
        this.content = this.content + '<img src="' + emoji.imageUrl + '" style="width: 25px; height: 25px; vertical-align: text-bottom;"/>';
      } else {
        this.content = this.content + emoji.native;
      }
    },
    toggleVisible() {
      this.isVisible = !this.isVisible;
    },
    async handleMessage(e) {
      e.preventDefault();

      if (this.isVideoEmbed(this.content)) {
        let dataUrl = null;
        const dataUrlMatch = this.hasDataUrl(this.content);
        if (dataUrlMatch) {
          dataUrl = dataUrlMatch[1];
        }

        this.content = this.content.replace(
          /<div[^>]*>(.*?<iframe[^>]*>.*?<\/iframe>.*?)<\/div>/,
          `<a href="${dataUrl}" data-url="${dataUrl}" target="_blank" rel="noopener noreferrer"></a>`,
        );
      }

      const hrefContent = this.content.replace(/<p>(\s*<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>\s*)<\/p>/gi, (match, fullLink, href, text) => {
        const decodeHtml = html => {
          const txt = document.createElement('textarea');
          txt.innerHTML = html;
          return txt.value;
        };

        const decodedHref = decodeHtml(href).replace(/\/$/, '');
        const decodedText = decodeHtml(text).trim().replace(/\/$/, '');

        const isExactUrl = decodedHref === decodedText;

        if (isExactUrl) {
          return `<a href="${href}" data-url="${href}" target="_blank" rel="noopener noreferrer"></a>`;
        }

        return match;
      });

      if (this.isAnchorTag(this.content)) {
        if (hrefContent) {
          this.content = hrefContent;
        } else {
          this.content = this.content;
        }
      }

      if (this.isUserLogin) {
        this.isVisible = false;
        this.sendFailed = false;
        let opinion = this.content.replace(/\u200B/g, '');

        if (opinion.trim() !== '') {
          try {
            this.$emit('sendMessage', e, {
              opinion,
              image: this.image,
              video: this.video,
              gif: this.gif ? this.gif.images.downsized.url : null,
              sendToRepresentatives: this.sendToRepresentatives,
            });

            this.content = '';
            this.image = null;
            this.video = null;
            this.gif = null;
            this.sendToRepresentatives = false;
          } catch (error) {
            this.sendFailed = true;
          }
        } else {
          this.sendFailed = true;
        }
      } else {
        window.location.href = '/user/login';
      }
    },
    handleGifsModal() {
      this.showGifsModal = !this.showGifsModal;
    },
    selectedGif(gif) {
      return (this.gif = gif);
    },
    removeGif() {
      return (this.gif = null);
    },
  },
  watch: {
    content(newContent) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.textIncludeUrl(newContent)) {
          this.textIsUrl = true;
        } else {
          this.textIsUrl = false;
        }
      }, 800);
    },
  },
};
</script>
<template>
  <div :class="{ 'opinion-box': true, 'with-background': withBackground }">
    <CpGrid align="center">
      <CpGridItem stretch-content :span="12" justify="center" style="word-break: break-all" :class="sendFailed ? 'input-error' : ''">
        <CpWysiwygInput
          block
          type="text"
          name="content"
          v-model="content"
          :placeholder="placeholder"
          style="font-size: 18px"
          class="opinion-textarea input"
        ></CpWysiwygInput>
        <OpenGraphPreview v-if="textIsUrl" :content="content" />
      </CpGridItem>
      <CpGridItem stretch-content :span="12" justify="center" class="box-add">
        <CpGrid>
          <CpGridItem stretch-content :span="$root.isPhone ? 12 : $root.isMobile ? 9 : 10">
            <CpGrid justify="spaceBetween" align="center">
              <CpGridItem stretch-content :span="image || video ? 12 : 'auto'">
                <span style="padding-right: 10px">Add </span>
                <button
                  type="button"
                  class="button"
                  @click="toggleVisible"
                  style="background-color: transparent; border: none"
                  :class="{ marginEmoji: mediaData }"
                >
                  <i class="fas fa-grin emoji-icon"></i>
                </button>
                <div v-if="isVisible" style="position: absolute">
                  <picker
                    :data="emojiData"
                    @select="addEmoji"
                    :autoFocus="true"
                    :emojiTooltip="false"
                    :i18n="categoriesData"
                    :perLine="$root.isMobile ? 7 : 8"
                    :emojiSize="emojiSize"
                    title=""
                    class="picker"
                    :class="{ marginPicker: !mediaData }"
                  />
                </div>
                <CpCloudinaryImageInput v-if="!video && !gif" :margin="0" :initial-value="image" v-model="image" :icon="true" style="position: initial" />
                <CpCloudinaryVideoInput
                  v-if="!image && !gif"
                  :width="1000"
                  :height="500"
                  :margin="0"
                  :initial-value="video"
                  v-model="video"
                  :icon="true"
                  :inputGroup="inputGroup"
                  style="position: initial"
                />
                <a @click="handleGifsModal" style="cursor: pointer">
                  <CpBaseSvgIcon
                    v-if="!video && !image && !gif"
                    :width="27"
                    :height="17"
                    :viewBox="'0 0 27 20'"
                    icon-color="var(--primary-blue-400)"
                    :stroke-color="'none'"
                    style="vertical-align: middle"
                  >
                    <GifIcon />
                  </CpBaseSvgIcon>
                </a>
              </CpGridItem>
              <CpGridItem stretch-content v-if="isMessagingToRep">
                <label class="checkbox-label">
                  <input type="checkbox" v-model="sendToRepresentatives" />
                  Send Comment To My Representatives
                </label>
              </CpGridItem>
            </CpGrid>
          </CpGridItem>
          <CpGridItem :span="$root.isPhone ? 12 : $root.isMobile ? 3 : 2" class="post-btn-container">
            <CpButton @click="handleMessage" :loading="loadingSend" :disabled="loadingSend" :primary="primaryBtnType" block
              ><span v-if="$root.isMobile"><i class="fas fa-paper-plane"></i></span> <span v-else>{{ submitButtonTitle }}</span></CpButton
            >
          </CpGridItem>
          <CpDialog v-if="showGifsModal">
            <CpModalGifs @close="handleGifsModal" :selectedGif="selectedGif" />
          </CpDialog>
          <div v-if="gif">
            <img class="gif-preview" :src="gif.images.downsized.url" alt="" /><br />
            <button type="button" class="btn" @click="removeGif">Remove</button>
          </div>
        </CpGrid>
      </CpGridItem>
    </CpGrid>
  </div>
</template>

<style scoped>
.marginEmoji {
  margin: 20px 0;
}
.emoji-icon {
  font-size: 16px;
  color: var(--primary-blue-400);
  margin-right: 10px;
}
.picker {
  position: absolute;
  z-index: 1;
}
.marginPicker {
  margin-top: 10px;
}
.input {
  padding: 8px 5px;
  font-size: 18px;
}
.input-error {
  border-bottom: 3px solid red !important;
}
.gif-preview {
  width: 100%;
  height: auto;
  padding-top: 20px;
  padding-bottom: 5px;
}
.button:focus {
  outline: none;
}
.btn {
  border: solid 1px #ff4814;
  text-shadow: none;
  text-decoration: none !important;
  box-shadow: none;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 400;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  color: #ff4814;
  display: inline-block;
  font-size: 16px;
  line-height: 1.3;
  text-align: center;
}
.opinion-box {
  box-sizing: border-box;
  padding: 10px;
}
.with-background {
  background-color: var(--neutral1);
}
.opinion-textarea {
  background-color: var(--white);
  border: 1px solid var(--neutral3);
  font: inherit;
  color: #8d8d8d;
  padding-left: 0px !important;
  min-height: 110px;
}
textarea {
  border-style: none;
  border-color: Transparent;
  outline: none;
}
.box-add {
  padding: 0px 10px;
  margin-top: 0;
}
.post-btn-container {
  display: flex;
  justify-content: flex-end;
  height: 32px;
}
.checkbox-label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: var(--neutral6);
  margin-top: 5px;
}
@media only screen and (max-width: 767px) {
  .picker {
    width: 280px !important;
  }
}
</style>
